module.exports = __webpack_public_path__ + "img/qrcode.05615a28.jpg";